import React from 'react';
import GenericListModule from "../../../../../core/gd-modules/generic-list/generic-list-module";
import {
    GlistColumnAlignment,
    GlistColumnType
} from "../../../../../core/gd-modules/generic-list/manager/columns-manager/column";
import { GlistColumnConfig } from "../../../../../core/gd-modules/generic-list/types/column-config";
import { GlistConfig } from "../../../../../core/gd-modules/generic-list/types/glist-config";
import {GlistHeaderMode} from "../../../../../core/gd-modules/generic-list/const";
import {FieldType} from "../../../../../core/fields3/field-type";
import FieldsCollection from "../../../../../core/fields3/collection/base/fields-collection";
import TeamProjectsGList_ProjectName from "../project-name";
import TeamProjectsGList_UserCounts from "../project-users-count";

export default class TeamProjectsGList extends GenericListModule {

    constructor() {

        const fieldsCollection = new FieldsCollection([
            {
                fieldId     : 'name',
                type        : FieldType.STRING,
                label       : 'Project name',
            },
            {
                fieldId     : 'users',
                type        : FieldType.NUMBER,
                label       : 'Users',
            }
        ])

        // Init columns
        const columns : GlistColumnConfig[] = [
            {
                type        : GlistColumnType.FIELD,
                fieldId     : 'name',
                width       : 350,
                component   : TeamProjectsGList_ProjectName
            },
            {
                type        : GlistColumnType.FIELD,
                fieldId     : 'users',
                width       : 200,
                component   : TeamProjectsGList_UserCounts
            }
        ]

        const config : GlistConfig = {
            skin: {
                className       : 'ui5-glist skin-modern gl-h-42',
                defaultAlignment: GlistColumnAlignment.LEFT,
                paddingLeft     : 0,
                paddingRight    : 0,
            },
            columns         : columns,
            headerMode      : GlistHeaderMode.STICKY,

            // titleField      : 'name',
        }

        super(fieldsCollection, config);
    }
}
